export async function AntpsicologicosUpdate(
  antpsicResp,
  antpsicFecha,
  antpsicTipo,
  antpsicTratprevRad,
  antpsicTratPrevRep,
  antpsicAfam,
  antpsicPfamRad,
  antpsicPfamEsp,
  antpsicPsocRad,
  antpsicPsocEsp,
  antpsicPlegRad,
  antpsicPlegEsp,
  antpsicPlabRad,
  antpsicPlabEsp,
  antpsicActtrat,
  antpsicRelinterpfam,
  antpsicRelinterptrab,
  antpsicRelinterpoc,
  antpsicVivadic,
  antpsicFampsiq,
  antpsicRelpadre,
  antpsicRelmadre,
  antpsicRelherm,
  antpsicRelpareja,
  antpsicRelhij,
  antpsicConvivact,
  antpsicEstciv,
  antpsicManutRad,
  antpsicManutEsp,
  antpsicExptrabaj,
  antpsicTrabaj,
  antpsicEstlabact,
  antpsicEduc,
  antpsicProfRad,
  antpsicProfEsp,
  antpsicTrafdrogRad,
  antpsicTrafdorgEsp,
  antpsicJuicRad,
  antpsicJuicEsp,
  antpsicCarcRad,
  antpsicCarcEsp,
  antpsicArrestRad,
  antpsicArrestEsp,
  antpsicSuicRad,
  antpsicSuicEsp,
  antpsicAlucRad,
  antpsicAlucEsp,
  antpsicApanRad,
  antpsicApanEsp,
  antpsicConvulRad,
  antpsicConvulEsp,
  antpsicPerdconcRad,
  antpsicPerdconcEsp,
  antpsicAmnlacRad,
  antpsicAmnlacEsp,
  antpsicPensparanRad,
  antpsicPensparanEsp,
  antpsicTratpsicofRad,
  antpsicTratpsicofEsp,
  antpsicTratpsiqRad,
  antpsicTratpsiqEsp,
  antpsicTerapdist,
  antpsicTerapcolabRad,
  antpsicAnamnesis,
  antpsicEntfamiliar,
  tratamientoId,
  pacienteId,
  antpsicologicosId
) {
  const formData = {
    title: `us-${pacienteId}-tr-${tratamientoId}-antpsic-${antpsicFecha}`,
    slug: `us-${pacienteId}-tr-${tratamientoId}-antpsic-${antpsicFecha}`,
    status: "publish",
    tratamiento: tratamientoId,
    paciente: pacienteId,
    meta: {
      antpsicResp: antpsicResp,
      metaFecha: antpsicFecha,
      antpsicTipo: antpsicTipo,
      antpsicTratprevRad: antpsicTratprevRad,
      antpsicTratPrevRep: antpsicTratPrevRep,
      antpsicAfam: antpsicAfam,
      antpsicPfamRad: antpsicPfamRad,
      antpsicPfamEsp: antpsicPfamEsp,
      antpsicPsocRad: antpsicPsocRad,
      antpsicPsocEsp: antpsicPsocEsp,
      antpsicPlegRad: antpsicPlegRad,
      antpsicPlegEsp: antpsicPlegEsp,
      antpsicPlabRad: antpsicPlabRad,
      antpsicPlabEsp: antpsicPlabEsp,
      antpsicActtrat: antpsicActtrat,
      antpsicRelinterpfam: antpsicRelinterpfam,
      antpsicRelinterptrab: antpsicRelinterptrab,
      antpsicRelinterpoc: antpsicRelinterpoc,
      antpsicVivadic: antpsicVivadic,
      antpsicFampsiq: antpsicFampsiq,
      antpsicRelpadre: antpsicRelpadre,
      antpsicRelmadre: antpsicRelmadre,
      antpsicRelherm: antpsicRelherm,
      antpsicRelpareja: antpsicRelpareja,
      antpsicRelhij: antpsicRelhij,
      antpsicConvivact: antpsicConvivact,
      antpsicEstciv: antpsicEstciv,
      antpsicManutRad: antpsicManutRad,
      antpsicManutEsp: antpsicManutEsp,
      antpsicExptrabaj: antpsicExptrabaj,
      antpsicTrabaj: antpsicTrabaj,
      antpsicEstlabact: antpsicEstlabact,
      antpsicEduc: antpsicEduc,
      antpsicProfRad: antpsicProfRad,
      antpsicProfEsp: antpsicProfEsp,
      antpsicTrafdrogRad: antpsicTrafdrogRad,
      antpsicTrafdorgEsp: antpsicTrafdorgEsp,
      antpsicJuicRad: antpsicJuicRad,
      antpsicJuicEsp: antpsicJuicEsp,
      antpsicCarcRad: antpsicCarcRad,
      antpsicCarcEsp: antpsicCarcEsp,
      antpsicArrestRad: antpsicArrestRad,
      antpsicArrestEsp: antpsicArrestEsp,
      antpsicSuicRad: antpsicSuicRad,
      antpsicSuicEsp: antpsicSuicEsp,
      antpsicAlucRad: antpsicAlucRad,
      antpsicAlucEsp: antpsicAlucEsp,
      antpsicApanRad: antpsicApanRad,
      antpsicApanEsp: antpsicApanEsp,
      antpsicConvulRad: antpsicConvulRad,
      antpsicConvulEsp: antpsicConvulEsp,
      antpsicPerdconcRad: antpsicPerdconcRad,
      antpsicPerdconcEsp: antpsicPerdconcEsp,
      antpsicAmnlacRad: antpsicAmnlacRad,
      antpsicAmnlacEsp: antpsicAmnlacEsp,
      antpsicPensparanRad: antpsicPensparanRad,
      antpsicPensparanEsp: antpsicPensparanEsp,
      antpsicTratpsicofRad: antpsicTratpsicofRad,
      antpsicTratpsicofEsp: antpsicTratpsicofEsp,
      antpsicTratpsiqRad: antpsicTratpsiqRad,
      antpsicTratpsiqEsp: antpsicTratpsiqEsp,
      antpsicTerapdist: antpsicTerapdist,
      antpsicTerapcolabRad: antpsicTerapcolabRad,
      antpsicAnamnesis: antpsicAnamnesis,
      antpsicEntfamiliar: antpsicEntfamiliar,
    },
  };

  const authToken = sessionStorage.getItem("token");

  try {
    const response = await fetch(
      `https://app.tavad.com/hce/wp-json/wp/v2/antpsicologicos/${antpsicologicosId}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      }
    );
    const values = await response.json();
    console.log(values);
    return values;
  } catch (error) {
    console.error(error);
  }
}
